import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch } from "vue";
  import plural from "@/features/plural";

  import InputSearch from "@/components/ui/input/InputSearch.vue";
  import { useStore } from "vuex";
  import { useToast } from "vue-toastification";
  import router from "@/router";
  import { debounce } from "@/helpers/debounce";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminBuilders',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();

  const loading = ref(true);
  const tableHeaders = ["Company", "Email", "Phone", "State"];
  const builders = ref([]);
  const searchQuery = ref("");
  const toast = useToast();

  onMounted(() => {
    getBuilders();
  });

  watch(
    () => searchQuery.value,
    () => {
      debounceSearch();
    }
  );

  const getBuilders = async () => {
    try {
      const res = await store.dispatch("builder/getBuilders", {
        name: searchQuery.value,
      });

      builders.value = res.data;
    } catch (error) {
      toast.error("Error getting builders");
    } finally {
      loading.value = false;
    }
  };
  const debounceSearch = debounce(getBuilders);
  const onClickBuilder = (id: string) => {
    router.push({ name: "AdminBuilder", params: { builderId: id } });
  };
  const toCreateBuilder = () => {
    router.push({ name: "AdminBuilderCreate" });
  };

const __returned__ = { store, loading, tableHeaders, builders, searchQuery, toast, getBuilders, debounceSearch, onClickBuilder, toCreateBuilder, ref, onMounted, watch, get plural() { return plural }, InputSearch, get useStore() { return useStore }, get useToast() { return useToast }, get router() { return router }, get debounce() { return debounce } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})